import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericGet } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY } from '@/swagger/constants/contents-likes-keys';
import { API_GET_CONTENTS_LIKES, KEY_GET_CONTENTS_LIKES } from '../constants';
import { MOCK_RESPONSE_GET_CONTENTS_LIKES } from '../mocks';
import { ContentLike } from '../types';

type ResponseGetContentsLikes = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY
>['response']['body'];

export type Content = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_LIKES_PATH_KEY
>['response']['body'][0]['content'];

export type CallParamsGetContentsLikes = {
  contentType: ContentLike;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponseGetContentsLikes = ResponseGetContentsLikes;

type CallErrorGetContentsLikes = {
  message: string;
  code: number;
};

type CallSelectorsGetContentsLikes = unknown;

export const getContentsLikesCall = createGeneralCall<
  CallParamsGetContentsLikes,
  CallResponseGetContentsLikes,
  CallErrorGetContentsLikes,
  CallSelectorsGetContentsLikes
>({
  id: KEY_GET_CONTENTS_LIKES,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_GET_CONTENTS_LIKES(org as unknown as string, payload.contentType);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  method: 'get',
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_GET_CONTENTS_LIKES : undefined,
});
